"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _beltech_coming_soon = _interopRequireDefault(require("../../../assets/images/beltech_coming_soon.webp"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ComingSoonPage = props => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  let {
    title,
    header
  } = props;
  title = title || t('Pages.Schedule.Title');
  header = header || t('Pages.ComingSoon.Header');
  (0, _react.useEffect)(() => {
    document.title = title;
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-flex__container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "con-heading"
  }, header)), /*#__PURE__*/_react.default.createElement("img", {
    className: "con-save-date-image",
    src: _beltech_coming_soon.default,
    alt: "Beltech 2023 is coming soon"
  })));
};
ComingSoonPage.propTypes = {
  title: _propTypes.default.string,
  header: _propTypes.default.string,
  content: _propTypes.default.string
};
var _default = exports.default = ComingSoonPage;